/* global Search, searchAZData, searchAZDataRaw */

if (document.querySelector(".fbjs-search--az")) {
    let hasActiveFilters = false;
    window.searchAZDataRaw = [];
    window.searchAZData = {
        aditionalInfo: {
            resetData: 1,
            displayExpertise: 0,
        },
        keyMarketEnergy: null,
        keyMarketEnvironment: null,
        expertise: {},
        softwareAndProducts: {
            software: null,
            products: null,
        },
        profile: null,
    };

    const sortData = () => {
        const alphabetTab = [
            "A",
            "B",
            "C",
            "D",
            "E",
            "F",
            "G",
            "H",
            "I",
            "J",
            "K",
            "L",
            "M",
            "N",
            "O",
            "P",
            "Q",
            "R",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
        ];
        var exp = searchAZDataRaw.filter(
            (el) => el.pageType === "Expertise - Expertise"
        );
        alphabetTab.map((el) => {
            searchAZData.expertise[el] = exp.filter((item) => {
                if ((item.title.charAt(0) == el) | el.toLowerCase()) {
                    searchAZData.aditionalInfo.displayExpertise = 1;
                    return true;
                } else {
                    return false;
                }
            });
        });

        searchAZData.keyMarketEnergy = searchAZDataRaw
            .filter(
                (el) =>
                el.pageType === "Key Market" &&
                el.url.includes("key-markets/energy")
            )
            .sort((a, b) => (a.title > b.title ? 1 : -1));

        searchAZData.keyMarketEnvironment = searchAZDataRaw
            .filter(
                (el) =>
                el.pageType === "Key Market" &&
                el.url.includes("key-markets/built-environment")
            )
            .sort((a, b) => (a.title > b.title ? 1 : -1));

        searchAZData.softwareAndProducts.software = searchAZDataRaw
            .filter((el) => el.pageType === "Expertise - Software")
            .sort((a, b) => (a.title > b.title ? 1 : -1));

        searchAZData.softwareAndProducts.products = searchAZDataRaw.filter(
            (el) => el.pageType === "Expertise - Product"
        );
        searchAZData.profile = searchAZDataRaw
            .filter((el) => el.pageType === "Expertise - SME Profile")
            .sort((a, b) => (a.title > b.title ? 1 : -1));

    };

    const buildHtml = async () => {
        let output = '<div class="results-wrapper--az">';

        /**
         *
         * @param {string} clickTrackingUrl - url to item
         * @param {string} title  - title of iteme
         * @returns  html
         */
        const barTemplate = (pageType,clickTrackingUrl, title, description) => {
            if(description !== undefined && (pageType === "Expertise - Software" || pageType === "Expertise - Product")){
                return `<div class="col-4 col-md-6 col-sm-12 col-lg-4 static-size-4 btn-container" tabindex="0">
                             <a tabindex="-1" 
                             class="btn btn--module-white btn--a-z" 
                             aria-expanded="false" 
                             href="https://wood-search01.squiz.co.uk${clickTrackingUrl}">
                            ${
                                pageType === "Expertise - Software"
                                    ? '<span class="btn-module-text">' +
                                      title +
                                      '<span class="expertise-type">/ software</span></span>'
                                    : ""
                            }
                            ${
                                pageType === "Expertise - Product"
                                    ? '<span class="btn-module-text">' +
                                      title +
                                      '<span class="expertise-type">/ product</span></span>'
                                    : ""
                            }
                            ${
                                pageType === "Expertise - Software" ||
                                pageType === "Expertise - Product"
                                    ? ""
                                    : title
                            }
                            </a>
                 <div class="btn-module-collapse">
                     <div class="truncate-lines-4">${description}</div>
                 </div>
             </div>`;

            } else {
                return `<div class="col-4 col-md-6 col-sm-12 col-lg-4 static-size-4 btn-container" tabindex="0">
                             <a tabindex="-1" 
                             class="btn btn--module-white btn--a-z" 
                             aria-expanded="false" 
                             href="https://wood-search01.squiz.co.uk${clickTrackingUrl}">
                            ${title}
                            </a>
             </div>`
            }
        }

        /**
         *
         * @param {[]} array array with items
         * @param {string} heading
         * @returns  html
         */
        const barWrapperTemplate = (array, heading) => {
            if (array.length) {
                let output = "";
                output += `<h5 class="a-z-listing--header-small heading-mobile-centered">${heading}</h5><div class="row expertise-row col-mobile-centered">`;

                array.map((el) => {
                    output += barTemplate(el.pageType,el.clickTrackingUrl, el.title, el.description);
                });

                output += `</div>`;
                return output;
            }
        };
        await sortData();

        /**
         * End markets
         */
        if (
            window.searchAZData.keyMarketEnergy.length ||
            window.searchAZData.keyMarketEnvironment.length
        ) {
            output += `<h2 class="a-z-listing--header-big heading-mobile-centered">End markets</h2>`;
        }

        output +=
            barWrapperTemplate(searchAZData.keyMarketEnergy, "Energy") || "";
        output +=
            barWrapperTemplate(
                searchAZData.keyMarketEnvironment,
                "Built Environment"
            ) || "";

        /**
         * Expertise
         */
        if (searchAZData.aditionalInfo.displayExpertise) {
            output += `<h2 class="a-z-listing--header-big heading-mobile-centered">Expertise</h2>`;

            const objKeys = Object.keys(searchAZData.expertise);
            for (let i = 0; i < objKeys.length; i++) {
                if (searchAZData.expertise[objKeys[i]].length) {
                    output += `
                        <h5 class="a-z-listing--header-small expertise-header heading-mobile-centered">${objKeys[i]}</h5>
                        <div class="row expertise-row col-mobile-centered">`;

                    [...searchAZData.expertise[objKeys[i]]].map((el) => {
                        output += barTemplate(el.pageType,el.clickTrackingUrl, el.title,el.description);
                    });
                    output += `</div>`;
                }
            }
        }

        /**
         * Software & Products
         */
        if (
            searchAZData.softwareAndProducts.software.length ||
            searchAZData.softwareAndProducts.products.length
        ) {
            output += `<h2 class="a-z-listing--header-big heading-mobile-centered">Software & Products</h2>`;
        }
        output +=
            barWrapperTemplate(
                searchAZData.softwareAndProducts.software,
                "Software"
            ) || "";
        output +=
            barWrapperTemplate(
                searchAZData.softwareAndProducts.products,
                "Products"
            ) || "";

        /**
         * Subject matter experts
         */
        if (searchAZData.profile.length) {
            output += `<h2 class="a-z-listing--header-big heading-mobile-centered">Subject Matter Experts</h2><div class="row experts-row col-mobile-centered">`;
            searchAZData.profile.map((el) => {
                output += `<div class="col-4 col-md-6 col-sm-12 col-lg-4 static-size-4">
                    <div class="profile-component profile-component--slick lightbox lightbox--js" data-lightbox-ajax-site="${el.url}" data-lightbox-special="profile">
                        <div class="profile-component__container">
                            <div class="profile-component__photo" style="background-image: url(${el.profileImage});">
                            </div>
                            <div class="profile-component__text">
                                <div class="profile-component__text-name">${el.title}</div>
                                <div class="profile-component__text-title">${el.profileJobTitle}</div>
                            </div>
                        </div>
                    </div>
                </div>`;
            });
            output += `</div>`;
        }

        output += "</div>";

        //removing old output after raload data
        var contntWrapper = document.querySelector("results-wrapper--az");
        if (contntWrapper) {
            contntWrapper.parentNode.removeChild(contntWrapper);
        }

        //displaing output on front
        document.querySelector(".results-wrapper").innerHTML = output;
    };

    if (document.querySelector(".fbjs-search--az")) {
        window.expertise = new Search.default({
            url: "https://wood-search01.squiz.co.uk/s/search.json",
            collections: ["wood-data"],
            additionalFBparams: {
                profile: "_default",
                gscope1: "expertiseListing",
            },
            onFiltersUpdate: () => {
                buildHtml();
                 const activeFilters =
                     window.searchArticles?.search.activeFacets;
                 for (const entry in activeFilters) {
                     if (activeFilters[entry].value !== []) {
                         hasActiveFilters = true;
                         return hasActiveFilters;
                     }
                 }
                searchAZData.aditionalInfo.resetData = 1;
            },
            beforeSearch: () => {
                //reset global data
                if (searchAZData.aditionalInfo.resetData) {
                    searchAZDataRaw = [];
                    searchAZData.keyMarketEnergy = null;
                    searchAZData.keyMarketEnvironment = null;
                    searchAZData.expertise = {};
                    searchAZData.softwareAndProducts.software = null;
                    searchAZData.softwareAndProducts.products = null;
                    searchAZData.profile = null;
                    searchAZData.aditionalInfo.resetData = 0;
                    searchAZData.aditionalInfo.displayExpertise = 0;
                }
            },
            results: {
                numRanks: 10000,
            },
            activeFacetsOnStart: {
                "f.pageType|pageType": [
                    // "expertise - software",
                    // "expertise - sme profile",
                    // "expertise - product",
                    // "expertise - expertise",
                    // "key market",
                ],
                "f.keyMarketEnergy|keyMarketEnergy": [],
                "f.keyMarketEnvironment|keyMarketEnvironment": [],
                "f.geographies|geographies": [],
            },

            pagination: {
                loadMore: false,
                arrows: false,
                arrowsOnEdgePages: false,
                dots: false,
                edgePages: false,
                pages: 0,
            },

            templates: {
                articleTemplate: (fields) => {
                    searchAZDataRaw.push({
                        type: fields.metaData.type,
                        clickTrackingUrl: fields.clickTrackingUrl,
                        summary: fields.summary,
                        date: fields.metaData.d,
                        id: fields.metaData.id,
                        pageType: fields.metaData.pageType,
                        description: fields.metaData.description,
                        title: fields.metaData.t,
                        keyMarketEnergy: fields.metaData.keyMarketEnergy,
                        keyMarketEnvironment:
                            fields.metaData.keyMarketEnvironment,
                        url: fields.displayUrl,
                        profileImage: fields.metaData.profileImage,
                        profileJobTitle: fields.metaData.profileJobTitle,
                    });
                    return ``;
                },

                /**
                 * @name informationTemplate
                 * @param fields
                 * @param resultsSummary
                 * @param h
                 * @returns {string}
                 */
                informationTemplate: () => {
                    return "";
                },
                formTemplate: (search, query, inputId) => {
                    query == "!nullsearch" ? (query = "") : null;
                    return `
                    <div class="search-field">
                        <form class="search__form" role="search" action="/search" method="get">
                            <label for="${inputId}" class="sr-only">Search site</label>
                            <input
                                id="${inputId}"
                                type="text"
                                class="search__form-input search-custom"
                                placeholder="A-Z search"
                                autocomplete="off"
                                role="searchbox"
                                aria-label="Search"
                                autocorrect="off"
                                autocapitalize="off"
                                spellcheck="false"
                                maxlength="1000"
                                aria-haspopup="menu"
                                aria-expanded="false"
                                value="${query}">
                            <button type="submit" name="site-search-submit" id="site-search-submit" class="search__submit">
                                <i class="search__submit-icon" aria-hidden="true"></i>
                                <span class="sr-only">Do search</span>
                            </button>
                            <div class="fb-search-wrapper"></div>
                        </form>
                    </div>
                    `;
                },

                /**
                 * @name paginationNumberTemplate
                 * @param number
                 * @param startrank
                 * @returns {string}
                 */
                paginationNumberTemplate: () => {
                    return ""; //<li class="hidden" data-startrank=${startrank} tabindex="0" >${number}</li>
                },

                /**
                 * @name activePaginationNumberTemplate
                 * @param number
                 * @returns {string}
                 */
                activePaginationNumberTemplate: () => {
                    return ""; //<li class="search__active-page hidden">${number}</li>
                },

                /**
                 * @name paginationTemplate
                 * @param pages
                 * @returns {string}
                 */
                paginationTemplate: (pages) => {
                    return `<div class="search__pagination">${pages}</div>`;
                },
                facetCheckbox: (
                    { categories, singleChoice },
                    activeFacets,
                    h
                ) => {
                    //{name, label}, activeFacets
                    // const header = label ? `<div>${label}</div>` : `<div>${name}</div>`;
                    let list = "";
                    list +=
                        '<li class="search__facet-item search__facet-item--all"></li>';

                    categories[0].values.forEach((item) => {
                        if (item.label !== "other") {
                            list += `<li class="search__facet-item">
                                    <label class="search__facet-label">
                                        <input
                                        class="search__facet-input"
                                        type="checkbox"
                                        ${item.checked}
                                        value="${item.data}"
                                        name="${item.label}"
                                        data-fparam="${h.queryStringParamName}"
                                        data-singlechoice="${singleChoice}"
                                        />
                                        <span class="search__facet-span">${item.label}</span>
                                    </label>
                                    </li>`;
                        }
                    });

                    return `<div class="checkbox-facet">
                            <ul class="search__facets">
                            ${list}
                            </ul>
                        </div>`;
                },

                /**
                 * @name noResults
                 * @param query
                 * @param spell
                 * @returns {string}
                 */
                noResults: () => {
                    // let spellSuggestion = "";
                    // if (spell.text) {
                    //     spellSuggestion = `<div>Did you mean: <a href="?${spell.url}">${spell.text}</a>?</div>`;
                    // }
                      if (hasActiveFilters) {
                          return `<div>There are no results matching your filter criteria</div>`;
                      } else {
                          return `<div>We're sorry, we couldn't find anything matching</div>`;
                      }
                },
            },
        });

        window.expertise.init();

    }
}
